<template>
  <div class="fixed bottom-5 right-5 z-50 space-y-3 max-w-sm">
    <TransitionGroup name="toast">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        :class="[
          'toast p-4 flex items-start gap-3 backdrop-blur-xl',
          toastTypeClass(toast.type)
        ]"
      >
        <div class="flex-shrink-0 mt-0.5">
          <CheckCircleIcon v-if="toast.type === 'success'" class="h-5 w-5" />
          <XCircleIcon v-else-if="toast.type === 'error'" class="h-5 w-5" />
          <ExclamationTriangleIcon v-else-if="toast.type === 'warning'" class="h-5 w-5" />
          <InformationCircleIcon v-else class="h-5 w-5" />
        </div>
        <div class="flex-1 min-w-0">
          <p class="text-sm font-medium leading-snug">{{ toast.message }}</p>
        </div>
        <button
          @click="removeToast(toast.id)"
          class="flex-shrink-0 opacity-50 hover:opacity-100 transition-opacity p-0.5 -m-0.5 rounded-lg"
        >
          <XMarkIcon class="h-4 w-4" />
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup>
import { useToast } from '@/composables/useToast'
import {
  CheckCircleIcon,
  XCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  XMarkIcon
} from '@heroicons/vue/24/outline'

const { toasts, removeToast } = useToast()

const toastTypeClass = (type) => {
  const classes = {
    success: 'bg-white dark:bg-surface-900 text-accent-700 dark:text-accent-400 border-accent-200 dark:border-accent-500/20',
    error: 'bg-white dark:bg-surface-900 text-red-700 dark:text-red-400 border-red-200 dark:border-red-500/20',
    warning: 'bg-white dark:bg-surface-900 text-amber-700 dark:text-amber-400 border-amber-200 dark:border-amber-500/20',
    info: 'bg-white dark:bg-surface-900 text-blue-700 dark:text-blue-400 border-blue-200 dark:border-blue-500/20'
  }
  return classes[type] || classes.info
}
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(100%) scale(0.95);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(40px) scale(0.95);
}

.toast-move {
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}
</style>
